import moment from "moment";
import React, { useEffect, useState } from "react";
import { withRouter } from "react-router-dom/cjs/react-router-dom.min";
import { Button, Row, Table } from "reactstrap";
import swal from "sweetalert";
import {
  CheckPermission,
  convertUTCToLocalTime,
  LoadingSpinner,
} from "../../../constants/const";
import { GetLanguageString, NoResult } from "../../helper/Components";
import {
  GetCustomStyles,
  GetPeriodName,
  GetSelectedLanguage,
} from "../../helper/Method";
import { addMember } from "../ApiMember";
import { useTranslation } from "react-i18next";
import LFCFilter from "../../helper/SearchFilter/LFCFilter";
import { IoAdd } from "react-icons/io5";
import { encryptStorage } from "../../../constants/EncryptStorage";

const UpdateLetterForCounselling = ({
  history,
  tab14,
  memberId,
  activeTab,
  setDiscard,
  discard,
  memberValues,
}) => {
  const [unitNames, setUnitNames] = useState([]);
  const loggedInMemberId = parseInt(encryptStorage.getItem("memberId"));
  const { t } = useTranslation();
  const [refresh, setRefresh] = useState(false);
  const [letterForCounsellingList, setLetterForCounsellingList] = useState([]);
  const [letterForCounselling, setLetterForCounselling] = useState({});
  const [letterForCounsellingYear, setLetterForCounsellingYear] = useState();
  const [letterForFrequency, setLetterForFrequency] = useState();
  const [letterForCounsellingFrequency, setLetterForCounsellingFrequency] =
    useState();
  const [isMemberCurrentLfcAdded, setIsMemberCurrentLfcAdded] = useState(true);
  const [loading, setLoading] = useState(false);

  let tempDate = new Date();
  tempDate.setDate(1);
  const [values, setValues] = useState({
    startDate: null,
    endDate: null,
    memberId: memberId,
  });

  useEffect(() => {
    if (tab14 === "active") {
      setLoading(true);
      addMember()
        .GetMemberLetterForCounselingData(values)
        .then((res) => {
          setLetterForCounsellingList(
            res.data.letterForCounsellingList
              ? res.data.letterForCounsellingList
              : []
          );
          setLetterForCounsellingFrequency(
            res.data.letterForCounsellingFrequency
              ? res.data.letterForCounsellingFrequency
              : 0
          );
          setLetterForCounselling(
            res.data.letterForCounselling ? res.data.letterForCounselling : 0
          );
          setLetterForCounsellingYear(
            res.data.letterForCounsellingYear
              ? res.data.letterForCounsellingYear
              : 0
          );

          setIsMemberCurrentLfcAdded(res.data.isMemberCurrentLfcAdded);
          setLetterForFrequency(
            res.data.letterForFrequency ? res.data.letterForFrequency : 0
          );
          setLoading(false);
        })
        .catch((err) => {
          swal({
            title: err,
            icon: "error",
            buttons: "OK",
          });
          setLoading(false);
        });
    }
  }, [memberId, values, tab14, refresh]);

  useEffect(() => {
    if (tab14 === "active") {
      if (activeTab && activeTab !== "tab14") {
        setDiscard(!discard);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeTab]);

  const handleDelete = (id) => {
    swal({
      title: t("common_delete_message"),
      text: t("common_delete_detail_message"),
      className: GetSelectedLanguage() === "en" ? "" : "ur",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        setLoading(true);
        addMember()
          .DeleteReceivedLetterForCounselling(id)
          .then(() => {
            swal({
              title: t(
                "member_member_detail_letter_for_counselling_delete_success"
              ),
              className: GetSelectedLanguage() === "en" ? "" : "ur",
              icon: "success",
              buttons: GetSelectedLanguage() === "en" ? "OK" : "ٹھیک ہے ",
            });
            setRefresh(!refresh);
            setLoading(false);
          })
          .catch((err) => {
            swal({
              title: err,
              icon: "error",
              buttons: "OK",
            });
            setLoading(false);
          });
      }
    });
  };

  useEffect(() => {
    let tempNames = [];

    letterForCounsellingList.forEach((element) => {
      tempNames.push({
        names: element.unitName.split("،"),
      });
    });

    setUnitNames(tempNames);
  }, [letterForCounsellingList]);

  const canAddLetter =
    !isMemberCurrentLfcAdded &&
    (loggedInMemberId === memberId ||
      CheckPermission("CanAddLetterForCouncelling"));

  const isLetterAllowedToAdd =
    letterForCounselling != null && (letterForCounselling.label === "ماہانہ" || letterForCounselling.label === "سہ ماہی" );

  return (
    <div role="tabpanel" id="tab-14" className={"tab-pane " + tab14}>
      <div className="panel-body" style={{ backgroundColor: "#f9f9f9" }}>
        {" "}
        <Row>
          {canAddLetter ? (
            isLetterAllowedToAdd ? (
              <div className={GetCustomStyles().btn_style}>
                <Button
                  color="default"
                  size="sm"
                  className={GetCustomStyles().btn_style}
                  onClick={() =>
                    history.push({
                      pathname: `/member/updateMember/letterForCounselling/${memberId}`,
                      state: {
                        memberId: memberId,
                        letterForCounselling: letterForCounselling,
                        memberValues: memberValues,
                        letterYear: letterForCounsellingYear,
                        letterFrequency: {
                          label: GetPeriodName(
                            letterForCounsellingFrequency,
                            letterForFrequency
                          ),
                          value: letterForFrequency,
                        },
                      },
                    })
                  }
                >
                  {" "}
                  <IoAdd
                    color="#18A689"
                    size={18}
                    style={{ marginRight: 3, marginBottom: 1 }}
                  />
                  <GetLanguageString props="settings_letter_for_counselling_add" />
                </Button>
              </div>
            ) : null
          ) : null}
        </Row>{" "}
        <LFCFilter values={values} setValues={setValues} />{" "}
        <div className="ibox">
          <div className="ibox-title">
            <h5>
              <GetLanguageString props="settings_letter_for_counsellings" />
            </h5>
          </div>
          <div className="ibox-content">
            {!loading ? (
              letterForCounsellingList.length !== 0 ? (
                <div className="table-responsive">
                  <Table responsive>
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>
                          {<GetLanguageString props="member_reg_number" />}
                        </th>
                        <th>
                          {
                            <GetLanguageString props="member_member_detail_letter_for_counselling_title" />
                          }
                        </th>
                        <th>
                          {
                            <GetLanguageString props="member_member_detail_responsibility_history" />
                          }
                        </th>
                        <th>
                          {
                            <GetLanguageString props="member_member_detail_unit_history" />
                          }
                        </th>
                        <th>
                          {
                            <GetLanguageString props="member_member_detail_letter_for_counselling_received_date" />
                          }
                        </th>
                        <th className="text-center">
                          {<GetLanguageString props="common_action" />}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {letterForCounsellingList.map((record, index) => {
                        return (
                          <tr key={index}>
                            <td>{index + 1}</td>
                            <td>{record.regNo}</td>
                            <td className="ur">
                              {record.title} (
                              {GetPeriodName(
                                record.letterFrequency,
                                record.letterForFrequency
                              )}{" "}
                              {record.year})
                            </td>
                            <td>
                              {record.responsibility.map((item, index) => {
                                return (
                                  <Button
                                    size="xs"
                                    color="info"
                                    key={index}
                                    className="label label-info m-r-xs"
                                  >
                                    <h5 className="ur">{item}</h5>
                                  </Button>
                                );
                              })}
                            </td>
                            <td className="ur">
                              <ol className="breadcrumb">
                                {unitNames[index]?.names?.map((item, index) => {
                                  return (
                                    <li
                                      className={
                                        GetSelectedLanguage() === "ur"
                                          ? "breadcrumb-item-ur"
                                          : "breadcrumb-item"
                                      }
                                      key={index}
                                    >
                                      {item}
                                    </li>
                                  );
                                })}
                              </ol>
                            </td>
                            <td>
                              {record.receivedAt
                                ? moment(
                                    convertUTCToLocalTime(record.receivedAt)
                                  ).format("DD/MM/yyyy")
                                : null}
                            </td>
                            <td className="text-center">
                              {CheckPermission("CanEditLetterForCouncelling") &&
                              loggedInMemberId !== memberId ? (
                                <Button
                                  color="white"
                                  size="sm"
                                  onClick={() => {
                                    history.push({
                                      pathname: `/member/updateMember/editLetterForCounselling/${memberId}`,
                                      state: {
                                        memberId: memberId,
                                        letterForCounselling: record.title,
                                        receivedLetterForCounsellingId:
                                          record.id,
                                        memberValues: memberValues,
                                        letterFrequency: record.letterFrequency,
                                        letterForFrequency:
                                          record.letterForFrequency,
                                        letterYear: record.year,
                                        receivedAt: record.receivedAt,
                                        calledAs: "edit",
                                      },
                                    });
                                  }}
                                >
                                  <GetLanguageString props="common_edit" />
                                </Button>
                              ) : null}
                              {CheckPermission(
                                "CanDeleteLetterForCouncelling"
                              ) && loggedInMemberId !== memberId ? (
                                <Button
                                  color="white"
                                  size="sm"
                                  onClick={() => handleDelete(record.id)}
                                >
                                  <GetLanguageString props="common_delete" />
                                </Button>
                              ) : null}
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </Table>
                </div>
              ) : (
                <NoResult />
              )
            ) : (
              LoadingSpinner()
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default withRouter(UpdateLetterForCounselling);
